/**
 * Flight Cost Estimates — thin wrapper over the shared AgentChatPanel.
 * All chat behavior lives in src/components/agent-chat/; this file only
 * supplies the flight-cost tool configuration. Shown on /tools/flight-cost
 * when VITE_FLIGHT_COST_AGENT_ENABLED=true (or ?ai=1 for early access).
 */
import { AgentChatPanel, type AgentChatToolConfig } from '@/components/agent-chat/AgentChatPanel';

const CONFIG: AgentChatToolConfig = {
	tool: 'flight-cost',
	title: (eventName) => `${eventName} — Flight Cost Estimates`,
	headerDescription: 'Estimate what it costs to fly the group to each destination, in plain language.',
	backLabel: 'Back to Flight Cost',
	composerPlaceholder: 'Message Flight Cost Estimates…',
	agentDisplayName: 'Flight Cost Estimates',
	splitStorageKey: 'flight-cost-agent-split',
	emptyStateHint: <>Ask about this event — for example &ldquo;Compare Phoenix and Bozeman for our dates&rdquo;, or drop a list of departure airports with passenger counts.</>,
	dropLabel: 'Drop an attendee list or a departure-airports list here',
	boardPlaceholder: 'The agent keeps its live status board here: what it needs from you, pricing runs in progress, and the latest results.',
};

/** Early-access/launch switch, same pattern as the R&P agent (VITE_RP_AGENT_ENABLED). */
export const FLIGHT_COST_AGENT_ENABLED =
	import.meta.env.VITE_FLIGHT_COST_AGENT_ENABLED === 'true' ||
	(typeof window !== 'undefined' && new URLSearchParams(window.location.search).get('ai') === '1');

export function FlightCostAgentPanel({ eventId, onClose }: { eventId: string; onClose: () => void }) {
	return <AgentChatPanel eventId={eventId} onClose={onClose} config={CONFIG} />;
}
